/**
 * JSON 解析包含大数字
 * @param {string} str - 包含大数字的字符串
 * @param {function} reviver - 自定义解析前处理
 * @return {object}
 */
export default function parseJsonWithBigInt(str, reviver) {
  if (!str) return
  try {
    const result = JSON.parse(
      str.replace(/(:)\s*?([0-9]{15,})([,}\]])?/g, '$1"$2"$3'),
      reviver
    )
    return result
  } catch (err) {
    return JSON.parse(str, reviver)
  }
}
